import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class QuoteDataService {
  private messageSource = new BehaviorSubject('default message');
  currentMessage = this.messageSource.asObservable();

  private dataSource = new BehaviorSubject('');
  recieveSoldToAddress = this.dataSource.asObservable();

  private soldToAddressDataNew = new BehaviorSubject(null);
  sendShipToAddress = this.soldToAddressDataNew.asObservable();

  private checkBoxData = new BehaviorSubject(false);
  recieveCheckBox = this.checkBoxData.asObservable();

  private chkShipToAddress = new BehaviorSubject(false);
  recieveShipToAddress = this.chkShipToAddress.asObservable();

  private shipToAddressData = new BehaviorSubject(null);
  sendEndCustomerAddress = this.shipToAddressData.asObservable();

  private endCustomerAddressData = new BehaviorSubject(null);
  setEndCustomerAddress = this.endCustomerAddressData.asObservable();

  private compliancequestionData = new BehaviorSubject(null);
  setCompliancequestion = this.compliancequestionData.asObservable();

  private submittedSource = new BehaviorSubject(null);
  recieveSubmittedFlags = this.submittedSource.asObservable();

  private shipToAddressLoggedin = new BehaviorSubject(null);
  recieveShipToAddressLoggedIN = this.shipToAddressLoggedin.asObservable();

  private endAddressLoggedin = new BehaviorSubject(null);
  recieveEndAddressLoggedIN = this.endAddressLoggedin.asObservable();

  private endUserIndustrySource =  new BehaviorSubject(null);
  recieveEndUserIndustry = this.endUserIndustrySource.asObservable();

  private billToAddressValidation = new BehaviorSubject(null)
  recieveBillToAddressValidation = this.billToAddressValidation.asObservable();

  
  private deliveryAddressValidation = new BehaviorSubject(null)
  recieveDeliveryAddressValidation = this.deliveryAddressValidation.asObservable();

  
  private endUserAddressValidation = new BehaviorSubject(null)
  recieveEndUserAddressValidation = this.endUserAddressValidation.asObservable();


  private complienceValidation = new BehaviorSubject(null)
  recieveComplienceValidation = this.complienceValidation.asObservable();

  private notificationValidation = new BehaviorSubject(null)
  recieveNotificationValidation = this.notificationValidation.asObservable();
  
  public soldAddressSource = new BehaviorSubject('');
  getSoldCountry = this.soldAddressSource.asObservable();

  public attachmentSource = new BehaviorSubject([]);
  getAttchments = this.attachmentSource.asObservable()

  constructor() {}

  changeMessage(message: string) {
    this.messageSource.next(message);
  }
  sendSoldToAddressData(data: any) {
    this.dataSource.next(data);
  }
  sendCheckBox(message: boolean) {
    this.checkBoxData.next(message);
  }

  setSoldAddressDataNew(data: any) {
    this.soldToAddressDataNew.next(data);
  }
  getSoldToAddressData() {
    return this.sendShipToAddress;
  }
  // Send Ship to Address Data
  setEndCustomerCheckBoxValue(message: boolean) {
    this.chkShipToAddress.next(message);
  }
  setShipToAddressData(data: any) {
    this.shipToAddressData.next(data);
  }
  getShipToAddressData() {
    return this.sendEndCustomerAddress;
  }

  sendSubmittedFlag(data: boolean) {
    this.submittedSource.next(data)
  }

  getCheckoutData() {
    const guestCheckoutData = {
      shippingDeatils: this.shipToAddressData.getValue(),
      soldToAddressDetails: this.soldToAddressDataNew.getValue(),
      endCustomerDetails: this.endCustomerAddressData.getValue(),
      complianceQuestionDetails: this.compliancequestionData.getValue()
    };
    return guestCheckoutData;
  }

  setEndCustomerData(data: any) {
    this.endCustomerAddressData.next(data);
  }

  sendLoggedinShipToAddress(data: any){
    this.shipToAddressLoggedin.next(data);
  }
  sendLoggedinEndAddress(data: any){
    this.endAddressLoggedin.next(data);
  }
  sendUserIndustry(data: any){
    this.endUserIndustrySource.next(data);
  }
  setCompliancequestionData(data: any){
    this.compliancequestionData.next(data);
  }
  // getcomplianceData(data: any){
  //   return this.setCompliancequestionData;
  // }

  sendBillToAddressValidation(valid: boolean){
    this.billToAddressValidation.next(valid);
  }

  sendShipToAddressValidation(valid: boolean){
    this.deliveryAddressValidation.next(valid);
  }

  sendEndUserAddressValidation(valid: boolean){
    this.endUserAddressValidation.next(valid);
  }

  sendComplieneceValidation(valid: boolean){
    this.complienceValidation.next(valid);
  }
  

  sendNotificationValidation(valid: boolean){
    this.notificationValidation.next(valid);
  }

  setSoldCountry(country){
    this.soldAddressSource.next(country);
  }

  sendAttachments(files){
    this.attachmentSource.next(files);
  }
}
